import { border } from 'components/storybook-migration/theme-provider/system-design/elements/border';
import { breakpoints } from 'components/storybook-migration/theme-provider/system-design/elements/breakpoints';
import { colors } from 'components/storybook-migration/theme-provider/system-design/elements/colors';
import { spacing } from 'components/storybook-migration/theme-provider/system-design/elements/spacing';
import { zIndex } from 'components/storybook-migration/theme-provider/system-design/elements/zIndex';
import { DefaultTheme } from 'styled-components';

export const cxTheme: DefaultTheme = {
  borderRadius: border,
  breakpoints: breakpoints,
  colors: colors,
  spacing: spacing,
  zIndex: zIndex,
} as DefaultTheme;
